import { jsx as _jsx } from "react/jsx-runtime";
import './button.scss';
const Button = (props) => {
    const { label, action, bottonColor, disabled, className, isAnimated } = props;
    return (_jsx("div", { className: `main-button ${disabled && 'main-button_disabled'} ${className ?? ''} ${isAnimated && !disabled ? 'is-animated' : ''}`, style: { backgroundColor: bottonColor }, onClick: action, children: label }));
};
export default Button;
